import { IntlShape } from 'react-intl'
import { create, enforce, omitWhen, test } from 'vest'
import type { BuyTogetherEffect } from '../../../../typings'
import { suite as benefitValidation } from './Benefit/validation'
import { messages } from './messages'
import { suite as triggerValidation } from './Trigger/validation'

export function suite(
  intl: IntlShape,
  triggerName: string,
  benefitName: string
) {
  return create((config: BuyTogetherEffect) => {
    const { trigger, benefit } = config
    const { $t } = intl
    const { validation } = messages

    test(triggerName, $t(validation.triggerEmpty), () => {
      enforce(trigger).isNotUndefined()
      enforce(trigger?.skus?.length).gt(0)
    })

    test(benefitName, $t(validation.benefitEmpty), () => {
      enforce(benefit).isNotUndefined()
      enforce(benefit?.skus?.length).gt(0)
    })

    omitWhen(!trigger, () => {
      test(triggerName, $t(validation.generic), () => {
        enforce(
          triggerValidation(intl, benefit)(trigger!).isValidByGroup('trigger')
        ).isTruthy()
      })
    })

    omitWhen(!benefit, () => {
      test(benefitName, $t(validation.generic), () => {
        enforce(
          benefitValidation(intl, trigger)(benefit!).isValidByGroup('benefit')
        ).isTruthy()
      })
    })
  })
}
